import { useQuery } from '@tallink/more-react-hooks'
import PropTypes from 'prop-types'
import qs from 'query-string'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useEffectOnce } from 'react-use'

import { initConfirmationPage } from '../actions/actions'
import Loader from '../components/common/Loader'
import Confirmation from '../components/confirmation/Confirmation'
import Summary from '../components/confirmation/Summary/Summary'
import ThankYouCallout from '../components/confirmation/ThankYouCallout/ThankYouCallout'
import Layout from '../components/layout/Layout'
import MainContent from '../components/layout/MainContent'
import { getMode, getReservation } from '../selectors/selectors'
import s from './ConfirmationPage.module.scss'

export default function ConfirmationPage() {
  const dispatch = useDispatch()
  const token = useQuery('resToken')
  const reservation = useSelector(getReservation)
  const [firstTime] = useState(useQuery('firstTime'))
  const history = useHistory()

  useEffectOnce(() => {
    dispatch(initConfirmationPage(token, firstTime))
    history.replace(qs.exclude(history.location.search, ['firstTime']))
  })

  return reservation ? <LoadedConfirmationPage firstTime={firstTime} /> : <LoadingConfirmationPage />
}

function LoadedConfirmationPage({ firstTime }) {
  const { t } = useTranslation()
  const reservation = useSelector(getReservation)
  const mode = useSelector(getMode)

  return (
    <Layout pageTitle={t(`mainPage.title.${mode}`)}>
      <div className={s['confirmation-page']}>
        <section className={s.header}>
          <h1 className={s['confirmation-page-heading']}>{t('confirmation.orderConfirmation')}</h1>
          {firstTime && <ThankYouCallout email={reservation.contactPerson.email} price={reservation.totalPrice} />}
        </section>
        <section>
          <MainContent aside={<Summary />} main={<Confirmation />} />
        </section>
      </div>
    </Layout>
  )
}

LoadedConfirmationPage.propTypes = {
  firstTime: PropTypes.string
}

function LoadingConfirmationPage() {
  const { t } = useTranslation()

  return (
    <Layout pageTitle={t('mainPage.title')}>
      <Loader />
    </Layout>
  )
}
